import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = (err) => {
  const errorMsg = err.response?.data?.message || err.response?.data?.error;
  const status = err.response?.status;

  if (status === 403) {
    toast.error("Você não tem permissão para realizar esta ação.", {
      toastId: errorMsg || "ERR_NO_PERMISSION",
    });
    return;
  }

  if (errorMsg) {
    if (i18n.exists(`backendErrors.${errorMsg}`)) {
      toast.error(i18n.t(`backendErrors.${errorMsg}`), {
        toastId: errorMsg,
      });
    } else {
      toast.error(errorMsg, {
        toastId: errorMsg,
      });
    }
  } else if (!err.response) {
    toast.error("Não foi possível conectar ao servidor. Tente novamente.");
  } else if (status >= 500) {
    toast.error(
      "Erro interno do sistema. Tente novamente ou contate o suporte.",
    );
  } else {
    toast.error(
      `Não foi possível concluir a ação (erro ${status || "desconhecido"}).`,
    );
  }
};

export default toastError;
